<template>
  <iframe :src="computedFrameUrl"
          width="900"
          height="1300"
          style="border:none;padding-bottom:96px;" />
</template>
<script>
import httpService from '@/helper/httpService';

export default {
  name: "KomedexPage",
  props: {
    frameUrl: {
      type: String,
      default: '/maklerportal/komedex.aspx'
    }
  },
  computed: {
    computedFrameUrl() {
      return httpService.adjustLegacyUrl(this.frameUrl);
    }
  }
};
</script>
